import React from 'react';
import { useLocation } from 'react-router-dom';
import AuthRightAnimation from '../../assets/img/auth/auth-right-animation.gif';
import NewLoginBg from '../../assets/img/agent-login-leo.png';

interface AuthPageRightSectionProps {
  isAgentContext?: boolean;
}

const AuthPageRightSection: React.FC<AuthPageRightSectionProps> = ({
  isAgentContext,
}) => {
  const location = useLocation();
  const showOnboardingLogin =
    isAgentContext ?? location.pathname === '/agent-login';

  if (showOnboardingLogin) {
    return (
      <div className='h-full relative rounded-[20px] overflow-hidden bg-reskin-primary-navy'>
        <img
          src={NewLoginBg}
          alt='agent-login-leo'
          className='w-full h-full object-contain'
        />
      </div>
    );
  }

  return (
    <div className='h-full bg-[url(/src/assets/img/auth/auth-right-static.svg)] bg-cover rounded-[20px]'>
      <img
        src={AuthRightAnimation}
        className='absolute bottom-4 left-1/2 -translate-x-1/2 h-2/5'
        alt='animation'
      />
    </div>
  );
};

export default AuthPageRightSection;
